import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Cobrás y a los días ya no sabés en qué se fue todo', 'Querés ahorrar pero siempre surge algo que lo impide', 'Llegás a fin de mes ajustado aunque creés que ganás bien', 'Tenés deudas que pagás pero que nunca terminan de bajar', 'Querés invertir pero no sabés por dónde empezar ni en qué confiar', 'Cada vez que hay una suba de precios sentís que retrocediste un paso más', 'Intentaste hacer presupuesto y lo abandonaste en menos de 2 semanas', 'Sentís que trabajás cada vez más y avanzás cada vez menos'];
  return <section className="bg-surface py-16 px-4 border-t border-border" data-id="element-141">
      <div className="max-w-4xl mx-auto" data-id="element-142">
        <div className="text-center mb-10" data-id="element-143">
          <h2 className="text-3xl md:text-5xl font-bold text-ink mb-6 leading-tight font-serif" data-id="element-144">
            ¿Cuántos meses más vas a terminar preguntándote a dónde fue todo?
          </h2>
          <p className="text-lg md:text-xl text-muted mb-4" data-id="element-145">
            Sos una persona que trabaja. Que se esfuerza. Que quiere mejorar su
            vida.
          </p>
          <p className="text-base md:text-lg text-ink/80 mb-6 font-medium" data-id="element-146">
            Pero nadie te explicó que en Argentina el sistema está diseñado para
            que tu plata desaparezca antes de que te des cuenta. La inflación te
            come el sueldo. Los bancos te cobran por todo. Los precios suben sin
            aviso.
          </p>
          <p className="text-lg md:text-xl font-bold text-primary" data-id="element-147">
            No es que sos mal administrador. Es que nunca te enseñaron a jugar
            en esta cancha.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-border shadow-sm" data-id="element-148">
          <h3 className="text-2xl font-bold text-ink mb-8 flex items-center font-serif" data-id="element-149">
            <XCircle className="w-8 h-8 text-urgency mr-3" data-id="element-150" />
            ¿Esto te suena familiar?
          </h3>

          <ul className="space-y-5" data-id="element-151">
            {points.map((point, i) => <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} key={i} className="flex items-start" data-id="element-152">
                <span className="text-urgency mr-4 text-xl mt-0.5" data-id="element-153">❌</span>
                <span className="text-base md:text-lg text-ink font-medium" data-id="element-154">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-155">
          <p className="text-2xl md:text-3xl font-bold text-ink italic font-serif" data-id="element-156">
            ¿Y si este fuera el último mes que lo pensás sin hacer nada?
          </p>
        </div>
      </div>
    </section>;
}